import type { ReactNode } from 'react';

interface Props {
  title: string;
  intro: string;
  children: ReactNode;
}

export function DashboardLayout({ title, intro, children }: Props) {
  return (
    <section>
      <h1>{title}</h1>
      <p className="lede">{intro}</p>
      <div className="dashboard-grid">{children}</div>
      <style>{styles}</style>
    </section>
  );
}

const styles = `
.lede { color: var(--ac-grey-500); max-width: 720px; margin-bottom: 16px; }
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  align-items: stretch;
}
`;
